import React, { useState } from "react";
import "./TimeForm.css";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";
import Checkbox from "@mui/material/Checkbox";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import Button from "@mui/material/Button";
import BottomNav from "../Nav/BottomNav";
import BackIconText from "../Icons/BackIconText";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { loadProjects } from "../Projects/projectSlice";
import { useDispatch } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import config from "../global/config";
import LoadingIcon from "../Icons/LoadingIcon";
import { Container } from "@mui/material";

const TimeForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const projects = useSelector((globalState) => globalState.projects.projects);
  if (!projects || projects.length == 0) {
    window.location.href = "/timesheets";
  }

  var today = new Date().toISOString().split("T")[0];

  const [errorMessage, setErrorMessage] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [roundOffMessage, setRoundOffMessage] = useState(false);
  const [timesheetId, setTimesheetId] = useState(
    state && state.timesheet ? state.timesheet.timesheetId : 0
  );
  const [project, setProject] = useState(
    state && state.timesheet && projects.length > 0
      ? {
          id: projects.filter((p) => p.id == state.timesheet.projectId)[0].id,
          label: projects.filter((p) => p.id == state.timesheet.projectId)[0]
            .name,
          isLeadInstructor: projects.filter(
            (p) => p.id == state.timesheet.projectId
          )[0].instructors[0].isLeadInstructor,
          classroomHrsEnabled: projects.filter(
            (p) => p.id == state.timesheet.projectId
          )[0].classroomHrsEnabled,
          preTripHrsEnabled: projects.filter(
            (p) => p.id == state.timesheet.projectId
          )[0].preTripHrsEnabled,
          publicRoadHrsEnabled: projects.filter(
            (p) => p.id == state.timesheet.projectId
          )[0].publicRoadHrsEnabled,
          skillsHrsEnabled: projects.filter(
            (p) => p.id == state.timesheet.projectId
          )[0].skillsHrsEnabled,
        }
      : null
  );
  const [trainees, setTrainees] = useState(
    state && state.timesheet
      ? state.timesheet.trainees.map((t) => {
          return {
            id: t.traineeId,
            title: t.firstName + " " + t.lastName,
            roadHours: t.publicRoadHours,
            skillsHours: t.skillsHours,
            rangeHours: t.range,
            preTripHours: t.preTripHours,
            classroomHours: t.classroomHours,
            theoryScore: t.theoryScore,
          };
        })
      : []
  );
  const [date, setDate] = useState(
    state && state.timesheet
      ? new Date(state.timesheet.date).toISOString().split("T")[0]
      : today
  );
  const [startTime, setStartTime] = useState(
    state && state.timesheet ? state.timesheet.startTime : ""
  );
  const [endTime, setEndTime] = useState(
    state && state.timesheet ? state.timesheet.endTime : ""
  );
  const [totalHours, setTotalHours] = useState(
    state && state.timesheet ? state.timesheet.totalHours : ""
  );
  const [moreThanThirtyMinutesToJob, setMoreThanThirtyMinutesToJob] = useState(
    state && state.timesheet
      ? state.timesheet.moreThanThirtyMinutesToJob
      : false
  );
  const [notes, setNotes] = useState(
    state && state.timesheet ? state.timesheet.notes : ""
  );
  const [isLoading, setIsLoading] = useState(false);
  const projectChoices = [];
  let traineeChoices = [];

  projects.forEach((project) => {
    if (project.projectStatus === "InProgress") {
      projectChoices.push({
        id: project.id,
        label: project.name,
        isLeadInstructor: project.instructors[0].isLeadInstructor,
        classroomHrsEnabled: project.classroomHrsEnabled,
        preTripHrsEnabled: project.preTripHrsEnabled,
        publicRoadHrsEnabled: project.publicRoadHrsEnabled,
        skillsHrsEnabled: project.skillsHrsEnabled,
      });
      var localArr = [];
      for (var i = 0; i < project.trainees.length; i++) {
        traineeChoices.push({
          id: project.trainees[i].id,
          projectId: project.trainees[i].projectId,
          title: project.trainees[i].title,
        });
      }
      // traineeChoices = localArr;
    }
  });

  const handleTimeRoundOff = (time) => {
    const minutesToRound = 15;
    const [hours, minutes] = (time || "").split(":").map(Number);

    if (minutes % 15 !== 0) {
      const rounded =
        Math.round((hours * 60 + minutes) / minutesToRound) * minutesToRound;
      const formattedTime = `${String(Math.floor(rounded / 60)).padStart(
        2,
        "0"
      )}:${String(rounded % 60).padStart(2, "0")}`;

      setRoundOffMessage(true);
      setTimeout(() => {
        setRoundOffMessage(false);
      }, 5000);
      return formattedTime;
    } else {
      return time;
    }
  };

  function handleTraineeForm(e, traineeId, propertyName) {
    var arrCopy = [...trainees];
    for (var i = 0; i < arrCopy.length; i++) {
      if (arrCopy[i].id == traineeId) {
        arrCopy[i][propertyName] = e.target.value;
        setTrainees(arrCopy);
        return;
      }
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);

    var token = localStorage.getItem("instructorToken");
    const url = config.baseUrl + "/command/instructor/timesheet";

    for (let num = 0; num < trainees.length; num++) {
      if (trainees[num].roadHours === "") {
        setErrorMessage(true);
        setIsSubmitting(false);
        return;
      }
      if (trainees[num].skillsHours === "") {
        setErrorMessage(true);
        setIsSubmitting(false);
        return;
      }
      if (trainees[num].preTripHours === "") {
        setErrorMessage(true);
        setIsSubmitting(false);
        return;
      }
      if (trainees[num].classroomHours === "") {
        setErrorMessage(true);
        setIsSubmitting(false);
        return;
      }
    }

    if (errorMessage !== true) {
      setIsLoading(true);
      const addTimesheetRequest = {
        TimesheetId: timesheetId,
        ProjectId: project.id,
        Date: date,
        StartTime: startTime,
        EndTime: endTime,
        TotalHours: totalHours,
        MoreThanThirtyMinutesToJob: moreThanThirtyMinutesToJob,
        Notes: notes,
        Trainees: trainees.map((t) => {
          return {
            traineeId: t.id,
            publicRoadHours: t.roadHours,
            skillsHours: t.skillsHours,
            preTripHours: t.preTripHours,
            classroomHours: t.classroomHours,
            theoryScore: t.theoryScore,
          };
        }),
      };
      if (
        addTimesheetRequest.TimesheetId &&
        addTimesheetRequest.TimesheetId > 0
      ) {
        axios
          .put(url, addTimesheetRequest, {
            headers: {
              Authorization: "Bearer " + token,
            },
          })
          .then((response) => {
            toast.success("Successfully updated timesheet.", {
              position: toast.POSITION.BOTTOM_CENTER,
            });

            axios
              .get(config.baseUrl + "/query/projects", {
                headers: { Authorization: `Bearer ${token}` },
              })
              .then((response) => {
                dispatch(loadProjects(response.data));
              });
          })
          .catch((ex) => {
            var healthUrl = config.baseUrl + "/query/health";
            toast.error("Failed to update timesheet", {
              position: toast.POSITION.BOTTOM_CENTER,
            });
            axios
              .get(healthUrl, { headers: { Authorization: `Bearer ${token}` } })
              .catch((ex) => {
                localStorage.removeItem("instructorToken");
                return <Navigate to="/" />;
              });
          })
          .then((x) => {
            setIsLoading(false);
            setIsSubmitting(false);
          });
      } else {
        axios
          .post(url, addTimesheetRequest, {
            headers: {
              Authorization: "Bearer " + token,
            },
          })
          .then((response) => {
            toast.success("Successfully created timesheet.", {
              position: toast.POSITION.BOTTOM_CENTER,
            });

            axios
              .get(config.baseUrl + "/query/projects", {
                headers: { Authorization: `Bearer ${token}` },
              })
              .then((response) => {
                dispatch(loadProjects(response.data));
              });
          })
          .catch((ex) => {
            toast.error("Failed to create timesheet.", {
              position: toast.POSITION.BOTTOM_CENTER,
            });
            var healthUrl = config.baseUrl + "/query/health";
            axios
              .get(healthUrl, { headers: { Authorization: `Bearer ${token}` } })
              .catch((ex) => {
                localStorage.removeItem("instructorToken");
                return <Navigate to="/" />;
              });
          })
          .then(() => {
            setIsLoading(false);
            window.location.href = "/timesheets";
          });
      }
    }
  }

  function handleProjectChange(event, newValue) {
    setProject(newValue);
    setTrainees([]);
  }

  function handleTraineeChange(event, newValue) {
    setTrainees(newValue);
  }

  function removeTrainee(id) {
    setTrainees(trainees.filter((t) => t.id != id));
  }

  var token = localStorage.getItem("instructorToken");

  if (!token) {
    return <Navigate to="/" />;
  }

  return (
    <>
      <Container>
        {isLoading && <LoadingIcon />}
        <ToastContainer />
        <h3
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/timesheets")}
        >
          <BackIconText></BackIconText>
        </h3>
        <form onSubmit={handleSubmit}>
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <h2 className={"header-text"}>Record your Training</h2>
            <TextField
              onChange={(event) => setDate(event.target.value)}
              id="date"
              label="Date"
              type="date"
              value={date}
              sx={{ width: "100%", mb: "12px" }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <h3 className={"header-text"} style={{ textAlign: "left" }}>
              Choose a Project
            </h3>
            <Autocomplete
              isOptionEqualToValue={(option, value) => option.id == value.id}
              value={project}
              onChange={(event, newValue) => setProject(newValue)}
              disablePortal
              id="combo-box-demo"
              options={projectChoices}
              sx={{ width: "100%", marginBottom: "30px", marginTop: "12px" }}
              renderInput={(params) => (
                <TextField {...params} label="Project Name" />
              )}
            />
            {roundOffMessage && (
              <div
                style={{
                  fontSize: "1.5rem",
                  padding: "1rem",
                  marginBottom: "1.8rem",
                  fontWeight: "bolder",
                  letterSpacing: "1px",
                  color: "white",
                  backgroundColor: "rgb(234, 113, 11)",
                  fontFamily: "Helvetica",
                }}
              >
                Your time has automatically been rounded to the nearest 15
                minute interval
              </div>
            )}
            <TextField
              value={startTime}
              required
              onChange={(event) => setStartTime(event.target.value)}
              onBlur={() => {
                setStartTime(handleTimeRoundOff(startTime));
              }}
              id="time"
              label="Start Time"
              type="time"
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 900, // 5 min
              }}
              sx={{ width: "100%", marginBottom: "30px" }}
            />
            <TextField
              value={endTime}
              required
              onChange={(event) => setEndTime(event.target.value)}
              onBlur={() => {
                setEndTime(handleTimeRoundOff(endTime));
              }}
              id="time"
              label="End Time"
              type="time"
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 900, // 5 min
              }}
              sx={{ width: "100%" }}
            />
          </div>
          {/* <Datetime className="timepicker-input" dateFormat={false} style={{width:"100%"}} timeConstraints={{minutes: {step: 15}}}/> */}
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <h3 className={"header-text"} style={{ textAlign: "left" }}>
                <svg
                  className={"icon"}
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22 10.9498C22.0019 9.51219 21.7195 8.08838 21.1694 6.75992C20.6193 5.43165 19.812 4.22505 18.7941 3.20963C17.4357 1.84949 15.7431 0.871368 13.8864 0.373505C12.0296 -0.124502 10.0745 -0.124502 8.21785 0.373505C6.36117 0.871368 4.66851 1.84949 3.31019 3.20963C1.92166 4.56175 0.916801 6.25814 0.398555 8.12577C-0.11969 9.99321 -0.132763 11.9646 0.360724 13.8389C0.854019 15.7131 1.83612 17.4228 3.20676 18.7932C4.57739 20.1636 6.28722 21.1459 8.16165 21.6392C10.036 22.1326 12.0081 22.1197 13.876 21.6018C15.744 21.0838 17.4409 20.0794 18.7932 18.6912C19.8113 17.6756 20.6184 16.469 21.1687 15.1407C21.7188 13.8122 22.001 12.3882 21.9991 10.9504L22 10.9498ZM11.5845 20.8141V20.15C11.5845 19.8551 11.3454 19.6159 11.0502 19.6159C10.7551 19.6159 10.516 19.8551 10.516 20.15V20.8141C8.26737 20.6937 6.12798 19.8061 4.45473 18.2993L4.921 17.833H4.92081C5.02405 17.7335 5.08275 17.5966 5.08406 17.4533C5.08518 17.31 5.0289 17.1723 4.92752 17.071C4.82615 16.9696 4.68843 16.9133 4.54512 16.9145C4.40181 16.9158 4.26484 16.9745 4.16533 17.0777L3.69888 17.5438V17.5436C2.1918 15.8709 1.30401 13.732 1.1836 11.4837H1.84778C2.14278 11.4837 2.38206 11.2447 2.38206 10.9496C2.38206 10.6544 2.14278 10.4154 1.84778 10.4154H1.1836C1.30398 8.16729 2.1918 6.02836 3.69888 4.35547L4.16533 4.82164V4.82145C4.37498 5.02398 4.70819 5.021 4.91428 4.81493C5.12039 4.60886 5.12338 4.27571 4.92081 4.06613L4.45454 3.59978H4.45473C6.12783 2.09303 8.26722 1.20543 10.516 1.08504V1.74908C10.516 2.04402 10.7551 2.28325 11.0502 2.28325C11.3454 2.28325 11.5845 2.04402 11.5845 1.74908V1.08504C13.8331 1.2054 15.9725 2.09303 17.6457 3.59978L17.1797 4.06613C17.0764 4.16562 17.0177 4.30257 17.0164 4.44584C17.0153 4.58912 17.0716 4.72681 17.1729 4.82817C17.2743 4.92952 17.412 4.98579 17.5553 4.98467C17.6987 4.98337 17.8356 4.92468 17.9351 4.82146L18.4016 4.35529V4.35548C19.9087 6.02822 20.7965 8.16715 20.9169 10.4154H20.2527C19.9577 10.4154 19.7184 10.6544 19.7184 10.9496C19.7184 11.2447 19.9577 11.4837 20.2527 11.4837H20.9169C20.7965 13.7318 19.9087 15.8708 18.4016 17.5437L17.9351 17.0777C17.8356 16.9745 17.6987 16.9158 17.5553 16.9145C17.412 16.9133 17.2743 16.9696 17.1729 17.071C17.0716 17.1723 17.0153 17.31 17.0164 17.4533C17.0177 17.5966 17.0764 17.7335 17.1797 17.833L17.6459 18.2993H17.6457C15.9726 19.8061 13.8332 20.6937 11.5845 20.8141ZM14.4716 13.6147C14.6803 13.8233 14.6803 14.1617 14.4716 14.3704C14.2629 14.5791 13.9244 14.5791 13.7157 14.3704L10.6725 11.3274C10.5722 11.2274 10.5159 11.0914 10.5159 10.9498V4.44436C10.5159 4.14942 10.755 3.9102 11.0502 3.9102C11.3454 3.9102 11.5845 4.14943 11.5845 4.44436V10.7289L14.4716 13.6147Z"
                    fill="#2D3C47"
                  />
                </svg>
                <span className={"text"}>&nbsp;&nbsp;Total Hours</span>
              </h3>
            </Grid>
            <Grid item xs={6}>
              <TextField
                required
                onChange={(event) => setTotalHours(event.target.value)}
                value={totalHours}
                id="outlined-basic"
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={2}>
              <Checkbox
                onChange={(e) => {
                  setMoreThanThirtyMinutesToJob(e.target.checked);
                }}
                defaultChecked={moreThanThirtyMinutesToJob}
                value="test"
                style={{
                  transform: "scale(1.4)",
                }}
                inputProps={{
                  "aria-label": "Traveled more than 30 minutes checkbox",
                }}
              />
            </Grid>
            <Grid item xs={10}>
              <p className={"checkbox-text"}>
                It took me more than 30 minutes to get to the job
              </p>
            </Grid>
          </Grid>
          {project && project.isLeadInstructor && (
            <>
              <Autocomplete
                value={trainees}
                multiple
                id="checkboxes-tags-demo"
                options={traineeChoices.filter(
                  (t) => t.projectId === project.id
                )}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                disableCloseOnSelect
                onChange={handleTraineeChange}
                getOptionLabel={(option) => option.title}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox style={{ marginRight: 8 }} checked={selected} />
                    {option.title}
                  </li>
                )}
                style={{ width: "100%", marginTop: "25px" }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Trainees"
                    placeholder="Choose Trainee(s)"
                  />
                )}
              />{" "}
              <div
                id="errorMessage"
                style={
                  errorMessage
                    ? {
                        backgroundColor: "red",
                        padding: "1rem",
                        marginTop: "0.8rem",
                        fontSize: "1.5rem",
                        color: "white",
                        display: "block",
                      }
                    : {
                        backgroundColor: "red",
                        padding: "1rem",
                        marginTop: "0.8rem",
                        fontSize: "1.5rem",
                        color: "white",
                        display: "none",
                      }
                }
              >
                Please fill all the required fields
              </div>
            </>
          )}
          {trainees.map((trainee, i) => {
            return !project.isLeadInstructor ? (
              <></>
            ) : (
              <>
                <div
                  style={{
                    backgroundColor: "#F7F7F9",
                    marginTop: "10px",
                    marginBottom: "25px",
                  }}
                  key={i}
                >
                  <Grid container>
                    <Grid item xs={12}>
                      <h3
                        className={"header-text"}
                        style={{ textAlign: "left" }}
                      >
                        {" "}
                        <span className={"text"}>{trainee.title}</span>
                        <svg
                          onClick={() => removeTrainee(trainee.id)}
                          style={{ float: "right" }}
                          className={"icon"}
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_15_1785)">
                            <path
                              d="M3 6H5H21"
                              stroke="#2D3C47"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6"
                              stroke="#2D3C47"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M10 11V17"
                              stroke="#2D3C47"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M14 11V17"
                              stroke="#2D3C47"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_15_1785">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </h3>
                    </Grid>
                  </Grid>
                  {true && (
                    <Grid container style={{ marginBottom: "10px" }}>
                      <Grid item xs={8}>
                        <InputLabel
                          htmlFor="roadHours"
                          sx={{ display: "inline" }}
                        >
                          Public road hrs
                        </InputLabel>
                      </Grid>
                      <Grid item xs={4}>
                        <Input
                          value={trainee.roadHours}
                          required
                          onChange={(e) => {
                            {
                              handleTraineeForm(e, trainee.id, "roadHours");
                              setErrorMessage(false);
                            }
                          }}
                          className="center-input"
                          type="number"
                        />
                      </Grid>
                    </Grid>
                  )}
                  {project.skillsHrsEnabled && (
                    <Grid container style={{ marginBottom: "10px" }}>
                      <Grid item xs={8}>
                        <InputLabel
                          htmlFor="skillsHours"
                          sx={{ display: "inline" }}
                        >
                          Skills & Pre-Trip Hrs
                        </InputLabel>
                      </Grid>
                      <Grid item xs={4}>
                        <Input
                          value={trainee.skillsHours}
                          required
                          onChange={(e) => {
                            handleTraineeForm(e, trainee.id, "skillsHours");
                            setErrorMessage(false);
                          }}
                          className="center-input"
                          id="skillsHours"
                          type="number"
                        />
                      </Grid>
                    </Grid>
                  )}
                  {project.preTripHrsEnabled && (
                    <Grid container style={{ marginBottom: "10px" }}>
                      <Grid item xs={8}>
                        <InputLabel
                          htmlFor="preTripHours"
                          sx={{ display: "inline" }}
                        >
                          Pre-Trip as group hrs
                        </InputLabel>
                      </Grid>
                      <Grid item xs={4}>
                        <Input
                          value={trainee.preTripHours}
                          required
                          onChange={(e) => {
                            handleTraineeForm(e, trainee.id, "preTripHours");
                            setErrorMessage(false);
                          }}
                          className="center-input"
                          id="preTripHours"
                          type="number"
                        />
                      </Grid>
                    </Grid>
                  )}
                  {project.classroomHrsEnabled && (
                    <Grid container style={{ marginBottom: "10px" }}>
                      <Grid item xs={8}>
                        <InputLabel
                          htmlFor="classroomHours"
                          sx={{ display: "inline" }}
                        >
                          Classroom hrs{" "}
                        </InputLabel>
                      </Grid>
                      <Grid item xs={4}>
                        <Input
                          value={trainee.classroomHours}
                          required
                          onChange={(e) => {
                            handleTraineeForm(e, trainee.id, "classroomHours");
                            setErrorMessage(false);
                          }}
                          className="center-input"
                          id="classroomHours"
                          type="number"
                        />
                      </Grid>
                    </Grid>
                  )}
                  {project.classroomHrsEnabled && (
                    <Grid container>
                      <Grid item xs={8}>
                        <InputLabel
                          htmlFor="theoryScore"
                          sx={{ display: "inline" }}
                        >
                          Theory Score{" "}
                        </InputLabel>
                      </Grid>
                      <Grid item xs={4}>
                        <Input
                          value={trainee.theoryScore}
                          required
                          onChange={(e) => {
                            handleTraineeForm(e, trainee.id, "theoryScore");
                            setErrorMessage(false);
                          }}
                          className="center-input"
                          id="theoryScore"
                          type="number"
                        />
                      </Grid>
                    </Grid>
                  )}
                </div>
              </>
            );
          })}

          <h3 className={"header-text"} style={{ textAlign: "left" }}>
            <span className={"text"}>Add Notes</span>
          </h3>
          <TextField
            onChange={(event) => setNotes(event.target.value)}
            value={notes}
            placeholder="Add Notes (optional)"
            multiline
            rows={4}
            style={{ width: "100%" }}
          />
          <Button
            disabled={isSubmitting}
            type="submit"
            id="submit-button"
            sx={{
              marginY: "25px",
              marginBottom: "100px",
              marginX: "auto",
              width: { xs: "100%", md: "auto" },
            }}
          >
            Submit
          </Button>
        </form>
        <BottomNav activePage="timesheets"></BottomNav>
      </Container>
    </>
  );
};

export default TimeForm;
